import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import useMediaQuery from "@mui/material/useMediaQuery";

const PRIMARY = "#1e293b";
const INDIGO = "#4f46e5";
const BG = "#f8fafc";

const features = [
  {
    icon: "📋",
    title: "Yozuv ro'yxati",
    desc: "Bemorlar uchun qabul jadvalini kunlik, haftalik va oylik rejimda boshqaring.",
  },
  {
    icon: "👥",
    title: "Bemorlar bazasi",
    desc: "Har bir bemor tarixi, muolajalar, to'lovlar va qarzdorliklar yagona sahifada.",
  },
  {
    icon: "👨‍⚕️",
    title: "Shifokorlar",
    desc: "Ish soatlari, jadval va mutaxassisliklar bo'yicha xodimlarni boshqaring.",
  },
  {
    icon: "🛎️",
    title: "Xizmatlar",
    desc: "Klinika xizmatlarini, narxlar va resurslarni sozlang.",
  },
  {
    icon: "💰",
    title: "Sotuv va to'lovlar",
    desc: "Naqt, Uzcard, Humo, Click va qarz bo'yicha to'lovlarni kuzating.",
  },
  {
    icon: "📦",
    title: "Mahsulotlar va ombor",
    desc: "Eshitish apparatlari va aksessuarlar bo'yicha ombor nazorati, serial raqamlar.",
  },
  {
    icon: "🔬",
    title: "Laboratoriya",
    desc: "Ishlab chiqarish va buyurtma mahsulotlar holatini real vaqtda kuzating.",
  },
  {
    icon: "📊",
    title: "Tahlil va hisobotlar",
    desc: "Daromad, xarajat, xodimlar samaradorligi bo'yicha batafsil statistika.",
  },
  {
    icon: "💼",
    title: "Ish haqi",
    desc: "Avtomatik va qo'lda ish haqi hisob-kitobi, oylik hisobotlar.",
  },
  {
    icon: "📱",
    title: "Telegram boti",
    desc: "Telegram orqali tizimga kiring va bildirishnomalar oling.",
  },
  {
    icon: "🔄",
    title: "Filiallar arasi",
    desc: "Mahsulotlarni filiallar o'rtasida o'tkazish va nazorat qilish.",
  },
  {
    icon: "🏢",
    title: "Ko'p filial",
    desc: "Bir necha filial va kompaniyalarni yagona tizimdan boshqaring.",
  },
];

const steps = [
  {
    n: "1",
    title: "Ro'yxatdan o'ting",
    desc: "Kompaniya nomi, login va parol bilan akkaunt oching — atigi 2 daqiqa.",
  },
  {
    n: "2",
    title: "Tizimni sozlang",
    desc: "Shifokorlar, xizmatlar va mahsulotlarni qo'shing, filialni sozlang.",
  },
  {
    n: "3",
    title: "Ishni boshlang",
    desc: "Bemorlarni qabul qiling, to'lovlarni kiriting va hisobotlarni kuzating.",
  },
];

const stats = [
  { value: "500+", label: "Faol foydalanuvchi" },
  { value: "10+", label: "Filial" },
  { value: "50k+", label: "Operatsiyalar" },
  { value: "99%", label: "Barqarorlik" },
];

export default function LandingPage() {
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width:768px)");

  const scrollToSection = (sectionId) => {
    document.getElementById(sectionId)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div
      style={{
        fontFamily: "'Inter', sans-serif",
        color: "#111827",
        background: "#fff",
        overflowX: "hidden",
      }}
    >
      {/* ── NAVBAR ── */}
      <nav
        style={{
          position: "sticky",
          top: 0,
          zIndex: 100,
          background: "#fff",
          borderBottom: "1px solid #e2e8f0",
        }}
      >
        <div
          style={{
            maxWidth: 1200,
            margin: "0 auto",
            padding: "0 24px",
            height: 64,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <img
            src="assets/images/logo/logo.png"
            alt="logo"
            style={{ height: 34, objectFit: "contain" }}
          />
          <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
            <button
              type="button"
              onClick={() => scrollToSection("features")}
              style={{
                background: "none",
                border: "none",
                cursor: "pointer",
                color: "#475569",
                fontWeight: 500,
                fontSize: 14,
                padding: "6px 10px",
              }}
            >
              Imkoniyatlar
            </button>
            <button
              type="button"
              onClick={() => scrollToSection("how")}
              style={{
                background: "none",
                border: "none",
                cursor: "pointer",
                color: "#475569",
                fontWeight: 500,
                fontSize: 14,
                padding: "6px 10px",
              }}
            >
              Qanday ishlaydi
            </button>
            <Button
              variant="outlined"
              size="small"
              onClick={() => navigate("/sign-in")}
              style={{
                borderColor: INDIGO,
                color: INDIGO,
                textTransform: "none",
                fontWeight: 600,
                marginLeft: 8,
              }}
            >
              Kirish
            </Button>
            <Button
              variant="contained"
              size="small"
              onClick={() => navigate("/sign-in")}
              style={{
                background: INDIGO,
                textTransform: "none",
                fontWeight: 600,
              }}
            >
              Boshlash
            </Button>
          </div>
        </div>
      </nav>

      {/* ── HERO ── */}
      <section
        style={{
          background: `linear-gradient(135deg, ${PRIMARY} 0%, #312e81 100%)`,
          color: "#fff",
          padding: "96px 24px 80px",
        }}
      >
        <div style={{ maxWidth: 780, margin: "0 auto", textAlign: "center" }}>
          <span
            style={{
              display: "inline-block",
              background: "rgba(255,255,255,0.1)",
              color: "#a5b4fc",
              padding: "5px 14px",
              borderRadius: 999,
              fontSize: 13,
              fontWeight: 600,
              marginBottom: 24,
              border: "1px solid rgba(165,180,252,0.25)",
            }}
          >
            🎧 Eshitish apparatlari klinikalari uchun
          </span>
          <h1
            style={{
              fontSize: "clamp(28px, 5vw, 52px)",
              fontWeight: 800,
              lineHeight: 1.2,
              margin: "0 0 20px",
            }}
          >
            Klinikangizni boshqarishning{" "}
            <span style={{ color: "#818cf8" }}>eng qulay</span> yo'li
          </h1>
          <p
            style={{
              fontSize: 17,
              color: "#cbd5e1",
              lineHeight: 1.75,
              margin: "0 auto 40px",
              maxWidth: 580,
            }}
          >
            Bemorlar, shifokorlar, sotuv, ombor va ish haqi — hammasi bir
            platformada. Telegram orqali tezkor kirish imkoniyati bilan.
          </p>
          <div
            style={{
              display: "flex",
              gap: 12,
              justifyContent: "center",
              flexWrap: "wrap",
            }}
          >
            <Button
              variant="contained"
              size="large"
              onClick={() => navigate("/sign-in")}
              style={{
                background: INDIGO,
                padding: "13px 32px",
                fontWeight: 700,
                fontSize: 16,
                textTransform: "none",
                borderRadius: 10,
              }}
            >
              Bepul boshlash →
            </Button>
            <Button
              variant="outlined"
              size="large"
              onClick={() => scrollToSection("features")}
              style={{
                borderColor: "rgba(255,255,255,0.3)",
                color: "#fff",
                padding: "13px 32px",
                fontWeight: 600,
                fontSize: 16,
                textTransform: "none",
                borderRadius: 10,
              }}
            >
              Imkoniyatlarni ko'rish
            </Button>
          </div>
        </div>
      </section>

      {/* ── STATS ── */}
      <section
        style={{
          background: BG,
          padding: "44px 24px",
          borderBottom: "1px solid #e2e8f0",
        }}
      >
        <div
          style={{
            maxWidth: 900,
            margin: "0 auto",
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
            gap: 24,
            textAlign: "center",
          }}
        >
          {stats.map((s) => (
            <div key={s.label}>
              <div style={{ fontSize: 36, fontWeight: 800, color: INDIGO }}>
                {s.value}
              </div>
              <div style={{ fontSize: 13, color: "#64748b", marginTop: 4 }}>
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ── FEATURES ── */}
      <section id="features" style={{ padding: "80px 24px" }}>
        <div style={{ maxWidth: 1160, margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: 52 }}>
            <h2
              style={{
                fontSize: 32,
                fontWeight: 800,
                margin: "0 0 10px",
                color: PRIMARY,
              }}
            >
              Barcha kerakli vositalar
            </h2>
            <p style={{ color: "#64748b", fontSize: 16, margin: 0 }}>
              Klinikangizni boshqarish uchun yagona platforma
            </p>
          </div>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
              gap: 18,
            }}
          >
            {features.map((f) => (
              <div
                key={f.title}
                style={{
                  background: BG,
                  border: "1px solid #e2e8f0",
                  borderRadius: 14,
                  padding: "24px 20px",
                  transition: "box-shadow 0.2s, border-color 0.2s",
                  cursor: "default",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow =
                    "0 4px 18px rgba(79,70,229,0.10)";
                  e.currentTarget.style.borderColor = "#c7d2fe";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = "none";
                  e.currentTarget.style.borderColor = "#e2e8f0";
                }}
              >
                <div style={{ fontSize: 28, marginBottom: 10 }}>{f.icon}</div>
                <h3
                  style={{
                    fontSize: 15,
                    fontWeight: 700,
                    margin: "0 0 6px",
                    color: PRIMARY,
                  }}
                >
                  {f.title}
                </h3>
                <p
                  style={{
                    fontSize: 13,
                    color: "#64748b",
                    margin: 0,
                    lineHeight: 1.6,
                  }}
                >
                  {f.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── TELEGRAM ── */}
      <section
        style={{
          background: "linear-gradient(135deg, #ede9fe 0%, #dbeafe 100%)",
          padding: "72px 24px",
        }}
      >
        <div
          style={{
            maxWidth: 860,
            margin: "0 auto",
            display: "grid",
            gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
            gap: isMobile ? 28 : 48,
            alignItems: "center",
          }}
        >
          <div>
            <span
              style={{
                display: "inline-block",
                background: INDIGO,
                color: "#fff",
                padding: "4px 12px",
                borderRadius: 999,
                fontSize: 12,
                fontWeight: 700,
                marginBottom: 16,
              }}
            >
              TELEGRAM BOT
            </span>
            <h2
              style={{
                fontSize: 28,
                fontWeight: 800,
                margin: "0 0 14px",
                color: PRIMARY,
              }}
            >
              Telegram orqali tezkor kirish
            </h2>
            <p
              style={{
                color: "#475569",
                lineHeight: 1.7,
                marginBottom: 20,
                fontSize: 15,
              }}
            >
              <strong>@crmzarinabot</strong> botiga /start yuboring va bevosita
              Telegram ichidan tizimga kiring. Telefon va kompyuterdan bir xil
              ishlaydi.
            </p>
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {[
                "Login/parolsiz tezkor kirish",
                "Bildirishnomalar Telegram orqali",
                "Mobil qurilmaga optimallashtirilgan",
              ].map((item) => (
                <div
                  key={item}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    color: "#374151",
                    fontSize: 14,
                  }}
                >
                  <span style={{ color: INDIGO, fontWeight: 700 }}>✓</span>{" "}
                  {item}
                </div>
              ))}
            </div>
          </div>
          <div
            style={{
              background: "#fff",
              borderRadius: 20,
              padding: 28,
              boxShadow: "0 8px 40px rgba(79,70,229,0.12)",
              textAlign: "center",
            }}
          >
            <div style={{ fontSize: 56, marginBottom: 12 }}>🤖</div>
            <div
              style={{
                fontSize: 18,
                fontWeight: 800,
                color: PRIMARY,
                marginBottom: 6,
              }}
            >
              @crmzarinabot
            </div>
            <div style={{ color: "#64748b", fontSize: 13, marginBottom: 20 }}>
              Telegram botiga o'ting va /start yuboring
            </div>
            <a
              href="https://t.me/crmzarinabot"
              target="_blank"
              rel="noreferrer"
              style={{ textDecoration: "none" }}
            >
              <Button
                variant="contained"
                fullWidth
                style={{
                  background: "#0088cc",
                  textTransform: "none",
                  fontWeight: 700,
                  padding: "11px 0",
                  borderRadius: 10,
                  fontSize: 14,
                }}
              >
                Telegram orqali ochish
              </Button>
            </a>
          </div>
        </div>
      </section>

      {/* ── HOW IT WORKS ── */}
      <section id="how" style={{ background: BG, padding: "80px 24px" }}>
        <div style={{ maxWidth: 720, margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: 48 }}>
            <h2
              style={{
                fontSize: 32,
                fontWeight: 800,
                margin: "0 0 10px",
                color: PRIMARY,
              }}
            >
              Qanday boshlash kerak?
            </h2>
            <p style={{ color: "#64748b", fontSize: 16, margin: 0 }}>
              3 oddiy qadamda ishga tushiring
            </p>
          </div>
          {steps.map((step, i) => (
            <div
              key={step.n}
              style={{
                display: "flex",
                gap: 20,
                alignItems: "flex-start",
                padding: "24px 0",
                borderBottom:
                  i < steps.length - 1 ? "1px solid #e2e8f0" : "none",
              }}
            >
              <div
                style={{
                  minWidth: 48,
                  height: 48,
                  background: INDIGO,
                  color: "#fff",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 20,
                  fontWeight: 800,
                  flexShrink: 0,
                }}
              >
                {step.n}
              </div>
              <div>
                <div
                  style={{
                    fontSize: 17,
                    fontWeight: 700,
                    marginBottom: 4,
                    color: PRIMARY,
                  }}
                >
                  {step.title}
                </div>
                <div
                  style={{ color: "#64748b", fontSize: 14, lineHeight: 1.65 }}
                >
                  {step.desc}
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ── CTA ── */}
      <section
        style={{
          background: `linear-gradient(135deg, ${PRIMARY} 0%, #312e81 100%)`,
          padding: "80px 24px",
          textAlign: "center",
        }}
      >
        <h2
          style={{
            fontSize: 32,
            fontWeight: 800,
            color: "#fff",
            margin: "0 0 12px",
          }}
        >
          Klinikangizni bugun raqamlashtiring
        </h2>
        <p style={{ color: "#94a3b8", fontSize: 16, marginBottom: 36 }}>
          Ro'yxatdan o'tish bepul. Hech qanday to'lov kerak emas.
        </p>
        <Button
          variant="contained"
          size="large"
          onClick={() => navigate("/sign-in")}
          style={{
            background: INDIGO,
            padding: "14px 48px",
            fontWeight: 700,
            fontSize: 17,
            textTransform: "none",
            borderRadius: 12,
          }}
        >
          Hoziroq boshlash →
        </Button>
      </section>

      {/* ── FOOTER ── */}
      <footer
        style={{
          background: "#0f172a",
          color: "#64748b",
          padding: "28px 24px",
          textAlign: "center",
        }}
      >
        <img
          src="assets/images/logo/logo-white.png"
          alt="logo"
          style={{ height: 26, marginBottom: 10, objectFit: "contain" }}
          onError={(e) => {
            e.target.style.display = "none";
          }}
        />
        <p style={{ margin: 0, fontSize: 13 }}>
          © 2025 Barcha huquqlar himoyalangan.
        </p>
      </footer>
    </div>
  );
}
